// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2fwEg","disabled":"FileBtn_disabled__2c6w6","warn":"FileBtn_warn__1HIvH","fade":"FileBtn_fade__2W_wK"};